<table
	mat-table
	class="list-container mb-3"
	[dataSource]="dataSource"
	matSort
	matSortActive="{{ sort.active }}"
	matSortDisableClear
	matSortDirection="{{ sort.direction }}"
>
	<ng-container matColumnDef="empty">
		<th mat-header-cell *matHeaderCellDef class="text-center">
			<div class="list-loader" *ngIf="loading$ | async">
				<mat-progress-bar mode="indeterminate"></mat-progress-bar>
			</div>
			<em *ngIf="loading$ | async">Loading railroads...</em>
			<em *ngIf="!(loading$ | async)">No associated railroads</em>
		</th>
	</ng-container>

	<ng-container matColumnDef="companyName">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Railroad Name</th>
		<td mat-cell *matCellDef="let railroad">
			<a [routerLink]="railroadsFragments.detail(railroad.id)">
				{{ railroad.companyName }}
			</a>
		</td>
	</ng-container>

	<ng-container matColumnDef="code">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Code</th>
		<td mat-cell *matCellDef="let railroad">
			{{ railroad.code }}
		</td>
	</ng-container>

	<ng-container matColumnDef="divisionLabel">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			Division Label
		</th>
		<td mat-cell *matCellDef="let railroad">
			{{ railroad.divisionLabel }}
		</td>
	</ng-container>

	<ng-container matColumnDef="employerIdentificationNumber">
		<th mat-header-cell *matHeaderCellDef>Tax ID</th>
		<td mat-cell *matCellDef="let railroad">
			{{ railroad.employerIdentificationNumber }}
		</td>
	</ng-container>

	<tr
		mat-header-row
		*matHeaderRowDef="resultColumns"
		[class.hidden]="dataSource.data.length < 1"
	></tr>
	<tr
		mat-header-row
		*matHeaderRowDef="emptyColumns"
		[class.hidden]="dataSource.data.length > 0"
	></tr>
	<tr mat-row *matRowDef="let railroad; columns: resultColumns"></tr>
</table>

<div fxLayout fxLayoutAlign="space-between center">
	<mat-paginator
		class.hidden="true"
		pageSize="5"
		[pageSizeOptions]="[5, 10]"
	></mat-paginator>
</div>
